import Model from "../Model";

class Representantclientzonetops extends Model{

    buildUrl ({ param }) {
        return ['employeeclientview/topzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantclientzonetops;